import {
    differenceInSeconds,
    differenceInMinutes,
    differenceInHours,
    differenceInDays,
    isBefore,
    intervalToDuration
} from 'date-fns';

// For formatting time until lot starts (during auction PREVIEW)
export const getTimeUntilString = (futureDateTime: Date): string => {
    const now = new Date();

    if (isBefore(futureDateTime, now)) {
        return "Auction started";
    }

    const seconds = differenceInSeconds(futureDateTime, now);
    const minutes = differenceInMinutes(futureDateTime, now);
    const hours = differenceInHours(futureDateTime, now);
    const days = differenceInDays(futureDateTime, now);

    if (seconds <= 60) {
        return "Starting soon";
    } else if (minutes < 60) {
        return `Starting in ${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
    } else if (hours < 24) {
        return `Starting in ${hours} ${hours === 1 ? "hour" : "hours"}`;
    } else {
        return `Starting in ${days} ${days === 1 ? "day" : "days"}`;
    }
};

// For formatting time left in a lot (during live auction)
export const formatTimeLeft = (milliseconds: number | undefined) => {
    if (!milliseconds) return "";

    if (milliseconds <= 0) return "Closed";

    // Convert milliseconds directly to days, hours, minutes, seconds
    const totalSeconds = Math.floor(milliseconds / 1000);
    const validDays = Math.floor(totalSeconds / (24 * 60 * 60));
    const validHours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const validMinutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const validSeconds = Math.floor(totalSeconds % 60);

    if (validDays > 1) {
        return `${validDays} days left`;
    } else if (validDays === 1) {
        return `${validDays} day left`;
    } else if (validHours >= 6) {
        return `${validHours}h left`;
    } else if (validHours > 0) {
        return `${validHours}h ${String(validMinutes).padStart(2, "0")}m left`;
    } else if (validMinutes > 0) {
        return `${String(validMinutes).padStart(2, "0")}:${String(validSeconds).padStart(2, "0")}`;
    } else if (validSeconds > 0) {
        return `00:${String(validSeconds).padStart(2, "0")}`;
    } else {
        return "Closed";
    }
};
